import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import moment from "moment";

import ExpirySettingPopup from "./ExpirySettingPopup";

import {
  getDocumentSettingsAction,
  // updatedDocumentSettingsAction,
} from "../../actions/DocumentActions";
import { readDataFromLocalStorage } from "../../utils/globalUtils";

class EsignExpiryDocSettings extends Component {
  state = {
    popUpVisible: false,
    isEnabled: false,
    dateStr: null,
    daysRemaining: null,
    dateRaw: null,
    isExpiryExtensionEnabled: false,
    esignType: "REVV",
  };

  componentDidMount = () => {
    this.props.getDocumentSettingsAction(this.props.docID).then(res => {
      res.forEach(item => {
        if (item.name === "link_expiry_time") {
          const date = moment(item.value);
          const now = moment.utc();
          const dateStr = date.utc().format("DD/MM/YY");
          const daysRemaining = date
            .startOf("day")
            .diff(now.startOf("day"), "days");
          this.setState({
            isEnabled: item.is_enabled,
            dateStr,
            daysRemaining,
            dateRaw: item.value,
          });
        }
      });
    });
  };

  componentDidUpdate() {
    const appFlag = readDataFromLocalStorage("appFlag");
    if (
      appFlag &&
      appFlag.esign_type &&
      appFlag.esign_type !== "REVV" &&
      appFlag.esign_type !== this.state.esignType
    ) {
      this.setState({ esignType: appFlag.esign_type, isEnabled: false });
    } else if (
      appFlag &&
      appFlag.esign_expiry_extension &&
      appFlag.esign_expiry_extension !== "DISABLED"
    ) {
      if (!this.state.isExpiryExtensionEnabled) {
        this.setState({ isExpiryExtensionEnabled: true });
      }
    }
  }

  _onExpiryExtended = newDate => {
    const now = moment().utc();
    const dateStr = newDate.utc().format("DD/MM/YY");
    const daysRemaining = newDate
      .startOf("day")
      .diff(now.startOf("day"), "days");
    const dateRaw = newDate.format();
    this.setState({
      dateStr,
      daysRemaining,
      popUpVisible: false,
      dateRaw,
    });
    this.props.getDocumentSettingsAction(this.props.docID);
  };

  _onClickPicker = () => {
    if (this.state.isExpiryExtensionEnabled) {
      this.setState({ popUpVisible: true });
    }
  };

  _onPickerClose = () => {
    this.setState({ popUpVisible: false });
  };

  render() {
    if (!this.state.isEnabled || this.state.esignType !== "REVV") {
      return null;
    }
    if (this.state.popUpVisible) {
      return (
        <ExpirySettingPopup
          docID={this.props.docID}
          onClose={this._onPickerClose}
          dateStr={this.state.dateStr}
          daysRemaining={this.state.daysRemaining}
          onCancel={this._onPickerClose}
          onExpiryExtended={this._onExpiryExtended}
          dateRaw={this.state.dateRaw}
        />
      );
    }

    let daysRemainingText = `${this.state.daysRemaining} day(s) from now`;
    if (this.state.daysRemaining === 0) {
      daysRemainingText = `Today`;
    } else if (this.state.daysRemaining < 0) {
      daysRemainingText = `${Math.abs(this.state.daysRemaining)} day(s) ago`;
    }

    return (
      <div className="esignexpirysetting-wrapper">
        <div className="esignexpirysetting-info-wrapper">
          <div className="esignexpirysetting-info-title">
            <FontAwesomeIcon
              icon={["far", "clock"]}
              className="esignexpirysettings-icon"
            />
            <span className="esignexpirysetting-info-head">
              Signature link expiry
            </span>
          </div>
          <div className="esignexpirysetting-info-sub-title">
            This document will expire on the chosen date. You can extend the
            duration too.
          </div>
          <div
            role="button"
            data-test="esign-expiry-extension-picker"
            className="esignexpirysetting-picker-container"
            onClick={this._onClickPicker}
            onKeyDown={this._onClickPicker}
            tabIndex="0">
            <div className="esignexpirysetting-picker-cont-in">
              <FontAwesomeIcon
                icon={["far", "calendar-alt"]}
                className="esignexpirysettings-icon"
              />
              <span className="esignexpirysetting-picker-date">
                {this.state.dateStr}
              </span>
              {this.state.isExpiryExtensionEnabled && (
                <FontAwesomeIcon
                  icon={["far", "edit"]}
                  className="esignexpirysettings-icon-edit"
                />
              )}
            </div>
            <div className="esignexpirysetting-picker-days">
              {daysRemainingText}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    document: { id: docID },
  } = state.DocumentStore;
  return {
    docID,
  };
};

const mapDispatchToProps = {
  getDocumentSettingsAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EsignExpiryDocSettings);
